import React, { Fragment, useEffect, useState, useContext } from "react";
import styled, { css } from "styled-components";
import { Context } from "../context";
import uniqid from "uniqid";
import { DayEntry } from "./DayEntry";
import { Link, withRouter } from "react-router-dom";
import { dateFormat, formatParamsToDate } from "./utils";
import { MenuDay } from "./MenuDay";

function DayGridInner({ children, history, match, location }) {
  const hours = [
    // 0, 1, 2, 3, 4, 5, 6, 7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
  ];

  const context = useContext(Context);
  const [localDate, setLocalDate] = useState();

  const [dateData, setDateData] = useState([]);

  // let usersForProjects = context.handles["getUsersForProjects"](
  //   localDate,
  //   context.state["activeProjects"]
  // );

  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (match) {
      // debugger;
    }
  }, [match]);

  const quarters = [0, 15, 30, 45];

  return (
    <>

      <div
      className={`l_timeline ${expanded ? "l_timeline--md" : "l_timeline--sm"}`}
      >

        {/* <div className="h0">
          <div
            className="ui_tabs"
            className="ui_tabs ui_tabs--expandable"
            onClick={() => setExpanded(!expanded)}
          >
            <div className="ui_tabs__ul">
              <div className="ui_tabs__li">
                <div className="ui_tabs__menu_item ui_tabs__menu_item--header ui_tabs__menu_item--header--light">
                  <div>Timelines</div>
                  <div className="m_ico m_ico--rotate">
                    {!expanded && <div>unfold_more</div>}
                    {expanded && <div>unfold_less</div>}
                  </div>
                </div>
              </div>
              <div className="ui_tabs__li ui_tabs__li--right">

              </div>
            </div>
          </div>
        </div> */}



        <MenuDay/>

        <div className="l_catalog">
          <div className="c_c">
            <div className="x_time0">
              {hours.map((oneHour) => {
                return (
                  <div className="x_time_hour0" key={uniqid()}>
                    <div className="x_time_hour_title">{oneHour}</div>

                    {!Boolean(
                      context.handles["getUsersForProjects"](
                        formatParamsToDate(match),
                        context.state["activeProjects"]
                      ).length
                    ) && (
                      <>
                        <div className="x_time_hour">
                          {quarters.map((quarter, ind) => (
                            <div className="x_time_hour" key={uniqid()}>
                              <div
                                className="x_time_hour_quarter"
                                key={uniqid()}
                              ></div>
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    {context.handles["getUsersForProjects"](
                      formatParamsToDate(match),
                      context.state["activeProjects"]
                    ).map((oneUser) => {
                      let userLogPerHour = oneUser["log"].filter(
                        (oneLogEntry) =>
                          oneLogEntry["start"].split(":")[0] ===
                          oneHour.toString()
                      );

                      return (
                        <div className="x_time_hour" key={uniqid()}>
                          {quarters.map((quarter, ind) => {
                            let logInThisHour = userLogPerHour
                              .filter(
                                (oneLogEntry) =>
                                  oneLogEntry["start"].split(":")[1] >=
                                  parseInt(quarter)
                              )
                              .filter(
                                (oneLogEntry) =>
                                  oneLogEntry["start"].split(":")[1] <
                                  parseInt(quarters[ind + 1])
                              )[0];
                            logInThisHour = logInThisHour
                              ? parseInt(logInThisHour["end"].split(":")[0]) -
                                parseInt(logInThisHour["start"].split(":")[0]) -
                                1
                              : 1;

                            return (
                              <div
                                className="x_time_hour_quarter"
                                key={uniqid()}
                              >
                                {Boolean(
                                  userLogPerHour.filter(
                                    (oneLogEntry) =>
                                      oneLogEntry["start"].split(":")[1] >=
                                      parseInt(quarter)
                                  ).length
                                ) &&
                                  Boolean(
                                    userLogPerHour.filter(
                                      (oneLogEntry) =>
                                        oneLogEntry["start"].split(":")[1] <
                                        parseInt(quarters[ind + 1])
                                    ).length
                                  ) && (
                                    <DayEntry
                                      userId={oneUser["id"]}
                                      hours={logInThisHour}
                                    />
                                  )}
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export const DayGrid = withRouter(DayGridInner);
